import { Circle } from "rc-progress";
import styled from "styled-components";

type Props = {
  value: string;
  textLength?: number;
  textMinLength?: number;
};
const LengthIndicator = ({ value, textLength = 500, textMinLength }: Props) => {
  const val = value?.trim()?.length ? value?.trim()?.length : 0;
  return (
    <StyledLengthIndicator>
      <Circle
        percent={Math.floor((val / textLength) * 100)}
        strokeWidth={8}
        strokeColor={
          val > textLength || val < textMinLength
            ? "var(--red)"
            : "var(--primary)"
        }
        style={{ width: 30, height: 30 }}
      />

      <span className="d-flex" style={{ lineHeight: 0 }}>
        {val > textLength ? "-" + Number(val - textLength) : val}
      </span>
    </StyledLengthIndicator>
  );
};

export default LengthIndicator;
const StyledLengthIndicator = styled.div`
  position: relative;
  display: flex;
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  & span {
    position: absolute;
  }
`;
